import * as React from 'react';
import './initialCoachingNotice.module.scss';

export const InitialCoachingNotice = () => (
    <div id="initial-coaching-notice" styleName="notice">
        <div styleName="title">初回コーチングについて</div>
        <div styleName="body">
            初回コーチングでは皆様の学習に対する想いや目標を詳しくヒアリングした上で目標設定を行います。そのため通常コーチングよりも長めの時間を設けてあります。
        </div>
    </div>
);
